import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { openLocationModal } from '../../actions/locationModal';
import { LocationButton } from '../../components/LocationButton';
import { PageHeader } from '../../components/PageHeader';
import { selectCurrentRegionName } from '../../selectors/currentRegion';
import { selectPageTitle } from '../../selectors/seoData';
import { SearchSuggestContainer } from '../SearchSuggestContainer';

export const PageHeaderContainer: React.FC = () => {
  const title = useSelector(selectPageTitle);
  const locationName = useSelector(selectCurrentRegionName);
  const dispatch = useDispatch();

  const handleLocationButtonClick = React.useCallback(() => {
    dispatch(openLocationModal());
  }, [dispatch]);

  return (
    <PageHeader
      title={title}
      location={<LocationButton onClick={handleLocationButtonClick}>{locationName}</LocationButton>}
      searchSuggest={<SearchSuggestContainer />}
    />
  );
};
